import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../core/services/base-api.service';
import { HolyQuranBaseDto } from '../../shared/models/holy-quran/holy-quran-base.dto';
import { PageResult } from '../../shared/models/page-result.model';

@Injectable({
  providedIn: 'root'
})
export class QuranDecorationsQuranService extends BaseApiService {
  protected override basePath = '/api';

  getHolyQuransByDecoration(decorationId: number, page: number = 1, pageSize: number = 9): Observable<{result: HolyQuranBaseDto[], totalElements: number}> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString())
      .set('SearchTerm', `QuranDecorationID:${decorationId}`);

    return this.get<PageResult<HolyQuranBaseDto>>('/HolyQuran', params).pipe(
      map(response => ({
        result: response.result || [],
        totalElements: response.totalElements || 0
      }))
    );
  }

  getDecorationById(id: number): Observable<any> {
    return this.get<any>(`/QuranDecoration/${id}`);
  }
}
